import { createGlobalStyle, css } from 'styled-components';
import type { CustomTheme } from '@/theme/types';

export default createGlobalStyle(
  ({ theme }: { theme: CustomTheme }) => css`
    *,
    *:after,
    *:before {
      box-sizing: border-box;
    }

    html,
    body {
      font: ${theme.font.style.normal} ${theme.font.weight.regular}
          ${theme.rems(16)} / 1.4 ${theme.font.family.speedee},
        ${theme.font.family.roboto}, 'Helvetica', 'Arial', sans-serif, system-ui,
        monospace;

      background-color: ${theme.color.white};
      color: ${theme.color.text};
      -webkit-user-select: none;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: ${theme.font.weight.bold};
      color: ${theme.color.text};
      letter-spacing: 0.01rem;
      line-height: 1.1;

      padding: 0;
      margin: 0;
    }

    a {
      text-decoration: underline;
      color: ${theme.color.text};

      padding: 0;
      margin: 0;

      &:hover,
      &:focus,
      &:active,
      &:visited {
        outline: none;
      }
    }

    b,
    strong {
      font-weight: ${theme.font.weight.bold};
      font-style: normal;
    }

    p,
    span {
      font-weight: ${theme.font.weight.regular};
      line-height: ${theme.rems(24)};
      color: ${theme.color.text};

      padding: 0;
      margin: 0;
    }

    button {
      font-family: ${theme.font.family.speedee};
      font-weight: ${theme.font.weight.bold};
      color: ${theme.color.text};

      cursor: pointer;
      outline: none;
      border: none;

      padding: 0;
      margin: 0;
    }

    img,
    svg,
    figure {
      vertical-align: top;
      max-width: 100%;
    }

    .grecaptcha-badge {
      pointer-events: none;
      visibility: hidden;
    }
  `
);
